import React from 'react'
import { FaGlobe, FaGithub } from 'react-icons/fa'


function ProjectItems({projectItems}) {
    return (
        <div className="projects">
            {
                projectItems.map((item)=>{
                    return <div className="project" key={item.id}>
                        <div className="project-content">
                            <div className="image-data">
                                <img src={item.image} alt=""/>
                                <ul className="hover-items">
                                    <li>
                                        <a href={item.link1} target="_blank"><FaGithub/></a>
                                        <a href={item.link2} target="_blank"><FaGlobe /></a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        
                        <h5>
                            {item.title}
                        </h5>
                        
                    </div>
                })
            }
        </div>
    )
}

export default ProjectItems;